export enum BusinessRole {
  STORE = 'STORE',
  COMPANY = 'COMPANY',
}
